import EditText from './edit-text';

export default EditText;
